import React from "react";
import PropTypes from "prop-types";

import { Button } from "@learningblocks/shared-components";
import { Modal } from "@learningblocks/shared-components/lib/Modal";
import { Title } from "./Title";
import { Description } from "./Description";
import { Wrapper } from "./Wrapper";

import "./style.scss";

/**
 * StepViewComplete:
 * - Modal window for Step Complete
 */

const TECHNIQUES__TAB = "TECHNIQUES";

export function StepViewComplete(props) {
  const onClickNext = () => props.onClickNext(TECHNIQUES__TAB);

  return (
    <Modal isOpen={props.isOpen} className="step-view-complete ">
      <Wrapper className="step-view-complete-modal">
        <Title />
        <Description />
        <Button
          onClick={onClickNext}
          className="step-view-complete-modal-button"
        >
          Next
        </Button>
      </Wrapper>
    </Modal>
  );
}

StepViewComplete.propTypes = {
  /**
   * Boolean set/reset to open/close modal
   */
  isOpen: PropTypes.bool,
  /**
   * Function to trigger something
   */
  onClickNext: PropTypes.func,
};

StepViewComplete.defaultProps = {
  isOpen: false,
};
